import type { CartItemTariff, SaleTariff } from '@src/core/buyerApiClient';

export type ItemTariff = CartItemTariff | SaleTariff;

const isSaleTariff = (tariff: ItemTariff): tariff is SaleTariff => 'unitPriceCurrencyInfo' in tariff;

export const getTariffUnitPriceCents = (tariff: ItemTariff): number =>
  isSaleTariff(tariff) ? tariff.unitPriceCurrencyInfo.amountCents ?? 0 : tariff.costPreview.unitPriceCents;
